import { useEffect, useState } from 'react';
import { getPAAAA010quick, putPAAAA010Banner, putPAAAA010ClickBanner } from '../../services/Api';
import moment from 'moment';
import ImageCheckFallback from './ImageCheckFallback';
const TopBanner = () => {
    const [dataBanner, setDataBanner] = useState(null);
    const [isPopupVisible, setPopupVisible] = useState(true);
    const [isChecked, setIsChecked] = useState(false);

    const getTextColor = (backgroundColor) => {
        if (!backgroundColor) return '#ffffff';

        const hex = backgroundColor.replace('#', '');

        const r = parseInt(hex.substring(0, 2), 16);
        const g = parseInt(hex.substring(2, 4), 16);
        const b = parseInt(hex.substring(4, 6), 16);

        const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;

        return luminance < 0.5 ? '#fff' : '#111';
    };

    const isLightBackground = (backgroundColor) => {
        if (!backgroundColor) return false;

        const hex = backgroundColor.replace('#', '');

        const r = parseInt(hex.substring(0, 2), 16);
        const g = parseInt(hex.substring(2, 4), 16);
        const b = parseInt(hex.substring(4, 6), 16);

        const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;

        return luminance < 0.5;
    };

    useEffect(() => {
        const closedBanner = localStorage.getItem('closedBanner');
        if (closedBanner) {
            const { expiry } = JSON.parse(closedBanner);
            if (moment().isBefore(moment(expiry))) {
                setPopupVisible(false);
            } else {
                localStorage.removeItem('closedBanner');
            }
        }
    }, []);

    const handleCheckboxChange = (event) => {
        setIsChecked(event.target.checked);
    };

    const handleClosePopup = () => {
        if (isChecked) {
            const expiryDate = moment().add(1, 'days').format('YYYY-MM-DD');
            localStorage.setItem('closedBanner', JSON.stringify({ value: 'true', expiry: expiryDate }));
        }
        setPopupVisible(false);
    };

    useEffect(() => {
        getPAAAA010quick()
            .then(({ data }) => {
                if (data.mainTop !== null) {
                    data.mainTop !== null && setDataBanner(data.mainTop[0]);
                    if (data.mainTop[0].seq.toString() === '') return;
                    putPAAAA010Banner(data.mainTop[0].seq.toString())
                        .then()
                        .catch((error) => console.log(error));
                }
            })
            .catch((error) => console.log(error));
    }, []);

    return (
        dataBanner &&
        dataBanner !== null &&
        isPopupVisible && (
            <div id="topBanner">
                <div className="topBanner-wrap" style={{ backgroundColor: `${dataBanner?.backgroundColor}` }}>
                    <div style={{ position: 'relative' }}>
                        <a
                            href={dataBanner?.linkUrl}
                            rel="nofollow"
                            target={dataBanner?.linkType === 'window' ? '_self' : dataBanner?.linkType}
                            onClick={async (e) => {
                                if (dataBanner?.linkType !== '_blank') {
                                    e.preventDefault();
                                }
                                await putPAAAA010ClickBanner(dataBanner?.seq);
                                try {
                                    if (dataBanner?.linkType === 'window') {
                                        window.open(dataBanner?.linkUrl, '_blank', 'width=800,height=600');
                                    } else if (dataBanner?.linkType !== '_blank') {
                                        window.location.href = dataBanner?.linkUrl;
                                    }
                                } catch (error) {
                                    console.log(error);
                                }
                            }}
                        >
                            <ImageCheckFallback
                                folderName={'banner_photo_maintop'}
                                imgName={dataBanner?.imgNameMain}
                                alt="Top Banners"
                                classImg={'topApds-img'}
                            />
                        </a>
                        <div className="close-topBanner-wrap">
                            <input
                                type="checkbox"
                                id="disappear"
                                name="disappear"
                                checked={isChecked}
                                onChange={handleCheckboxChange}
                            />
                            <label style={{ color: getTextColor(dataBanner?.backgroundColor) }} htmlFor="disappear">
                                오늘 하루 창 열지 않음
                            </label>

                            <button
                                className={`close-banner ${
                                    isLightBackground(dataBanner?.backgroundColor) ? 'light' : ''
                                }`}
                                onClick={handleClosePopup}
                            />
                        </div>
                    </div>
                </div>
            </div>
        )
    );
};

export default TopBanner;
